import React, { useState } from 'react';

import { connect } from 'react-redux';

import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';

import { employeeDirectoryImportForIdSelector } from '../../employee-directory-import-selectors';

import { UiButton } from '../../../ui/ui-button';
import { UiDialog } from '../../../ui/ui-dialog';

import { EmployeeDirectoryImportWizardContactMatchingContacts } from './employee-directory-import-wizard-contact-matching-contacts';
import { EmployeeDirectoryImportDataConfirmation } from './employee-directory-import-wizard-data-confirmation';
import { EmployeeDirectoryImportDataMatching } from './employee-directory-import-wizard-data-mapping';
import { EmployeeDirectoryImportWizardExternalIdMatchingEmployees } from './employee-directory-import-wizard-external-id-matching-employees';
import { EmployeeDirectoryImportGroups } from './employee-directory-import-wizard-groups';
import { EmployeeDirectoryImportHeaderConfirmation } from './employee-directory-import-wizard-header-confirmation';
import { EmployeeDirectoryImportWizardNewEmployees } from './employee-directory-import-wizard-new-employees';
import { EmployeeDirectoryImportWizardPartiallyMatchingContacts } from './employee-directory-import-wizard-partially-matching-contacts';
import { EmployeeDirectoryImportWizardRemoveEmployees } from './employee-directory-import-wizard-remove-employees';
import { EmployeeDirectoryImportWizardSuccess } from './employee-directory-import-wizard-success';
import { EmployeeDirectoryImportSupervisors } from './employee-directory-import-wizard-supervisors';

interface InputProps {
  employeeDirectoryImportId: number;
}

const mapStateToProps = (state: any, { employeeDirectoryImportId }: InputProps) => ({
  employeeDirectoryImport: employeeDirectoryImportForIdSelector(state, employeeDirectoryImportId),
});

type ReduxProps = ReturnType<typeof mapStateToProps>;
type Props = InputProps & ReduxProps;

const WIZARD_STEPS = [
  EmployeeDirectoryImportHeaderConfirmation,
  EmployeeDirectoryImportDataMatching,
  EmployeeDirectoryImportDataConfirmation,
  EmployeeDirectoryImportWizardExternalIdMatchingEmployees,
  EmployeeDirectoryImportWizardContactMatchingContacts,
  EmployeeDirectoryImportWizardPartiallyMatchingContacts,
  EmployeeDirectoryImportWizardNewEmployees,
  EmployeeDirectoryImportWizardRemoveEmployees,
  EmployeeDirectoryImportGroups,
  EmployeeDirectoryImportSupervisors,
  EmployeeDirectoryImportWizardSuccess,
];

export const EmployeeDirectoryImportWizard = connect(mapStateToProps)(
  ({ employeeDirectoryImportId, employeeDirectoryImport }: Props) => {
    const [dialogVisible, setDialogVisible] = useState<boolean>(false);
    const [wizardStep, setWizardStep] = useState<number>(0);
    const [previousStepData, setPreviousStepData] = useState<any>(null);

    const toggleDialog = () => setDialogVisible(!dialogVisible);
    const nextStep = (data?: any) => {
      if (data) {
        setPreviousStepData(data);
      } else {
        setPreviousStepData(null);
      }

      if (wizardStep + 1 < WIZARD_STEPS.length) {
        setWizardStep(wizardStep + 1);
      } else {
        toggleDialog();
      }
    };

    const previousStep = (data?: any) => {
      if (data) {
        setPreviousStepData(data);
      } else {
        setPreviousStepData(null);
      }

      if (wizardStep - 1 >= 0) {
        setWizardStep(wizardStep - 1);
      } else {
        toggleDialog();
      }
    };

    const CurrentComponent = WIZARD_STEPS[wizardStep];

    return (
      <>
        <UiButton onClick={toggleDialog} disabled={Boolean(employeeDirectoryImport?.completedAt)}>
          Import Employees
        </UiButton>
        {dialogVisible ? (
          <UiDialog onClose={toggleDialog} title="Import Employee List" size="lg">
            <CurrentComponent
              employeeDirectoryImportId={employeeDirectoryImportId}
              onNext={nextStep}
              onCancel={toggleDialog}
              onPrevious={previousStep}
              previousStepData={previousStepData}
              PageIndicator={() => (
                <Stepper activeStep={wizardStep} alternativeLabel>
                  {WIZARD_STEPS.map((component) => (
                    <Step key={component.toString()}>
                      <StepLabel />
                    </Step>
                  ))}
                </Stepper>
              )}
            />
          </UiDialog>
        ) : null}
      </>
    );
  },
);
